import type { IconProps } from '../types/IconProps.ts';
export const ArrowLeftFromLine: IconProps = {
    name: 'ArrowLeftFromLine',
    children: [
        `<path d="m9 7-5.87 5.8c-.17.1-.17.29 0 .4L9 19M5 13h12M21 6v14" />`,
    ]
};